// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"422f9f59","740":"852afa0a"}[chunkId] + ".chunk.css";
};